<template>
  <div class="increase-edit-padding">
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
      <!-- 登录用户名 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Login Name"
        hasFeedback
      >
        <a-input
          placeholder="Pleass input your login name (5-20 characters)."
          v-decorator="[
            'userName',
            {rules: [{ min: 5, max: 20, required: true, message: 'Please input login name (5-20 characters).' }]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 密码 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Password"
        hasFeedback
        v-if="createFlag"
      >
        <a-input
          style="-webkit-text-security:disc;"
          placeholder="Pleass input your password (6-20 characters)."
          v-decorator="[
            'password',
            {rules: [{ min: 6, max: 20, required: true, message: 'Please input password (6-20 characters).' }]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 确认密码 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Confirm Password"
        hasFeedback
        v-if="createFlag"
      >
        <a-input
          style="-webkit-text-security:disc;"
          placeholder="Pleass input your confirm password (6-20 characters)."
          v-decorator="[
            'confirmPassword',
            {rules: [{ min: 6, max: 20, required: true, message: 'Please input confirm password (6-20 characters).' }, {validator: passwordConfirmValidator}]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 邮箱地址 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="EMail"
        hasFeedback
      >
        <a-input
          placeholder="EMail"
          v-decorator="[
            'email',
            {rules: [{ type: 'email', required: true, message: 'Please input email.' }]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 手机号码 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Mobile"
        hasFeedback
      >
        <a-input
          placeholder="Mobile"
          v-decorator="[
            'mobile',
            {rules: [{ required: false, message: 'Please input mobile.' }]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 启用状态 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Enabled"
        hasFeedBack
      >
        <a-switch v-decorator="['enabledSwitch', { valuePropName: 'checked' }]" />
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Roles"
        hasFeedback
        v-if="roleList"
      >
        <a-select
          style="width: 100%"
          mode="multiple"
          v-model="adminerRoles"
          :allowClear="true"
        >
          <a-select-option v-for="role in roleList" :key="role.id" :value="role.id">{{ role.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 隐藏域 -->
      <a-form-item v-show="false"><a-input v-decorator="['id']"/></a-form-item>
      <a-form-item v-bind="buttonCol">
        <a-row class="btn-box" style="padding-left: 16.5%;">
          <a-button type="primary" html-type="submit">Save</a-button>
          <a-button style="margin-left: 8px;" @click="handleGoBack">Cancel</a-button>
        </a-row>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { addAdminer, updateAdminer, getAdminerDetail } from '@/api/api-adminer'
import { roleList } from '@/api/api-role'

export default {
  name: 'AdminerEdit',
  props: {
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      createFlag: false,
      // 所有角色列表
      roleList: null,
      // 当前用户拥有的角色
      adminerRoles: undefined
    }
  },
  // beforeCreate () {
  //   this.form = this.$form.createForm(this)
  // },
  mounted () {
    // 获取所有可用系统角色，备选
    roleList().then(res => {
      this.roleList = res.data
      // 获取当前用户详情, 读取当前用户的所有角色
      if (this.record !== '') {
        this.loadAdminerDetail(this.record.id)
      }
    })
    this.$nextTick(() => {
      this.loadEditInfo(this.record)
    })
  },
  methods: {
    // 读取管理员详情
    loadAdminerDetail (id) {
      getAdminerDetail(id).then(res => {
        const adminer = res.data
        console.debug('adminer.roles', adminer.roles)
        this.adminerRoles = adminer.roles.map(t => t.id)
      })
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit (e) {
      e.preventDefault()
      // eslint-disable-next-line
      this.editForm.validateFields((err, fieldsValue) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        formData.enabledFlag = formData.enabledSwitch ? '1' : '0'
        formData.roleIdList = this.adminerRoles
        // 添加
        if (formData.id === null) {
          addAdminer(formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Adminer save successfully !')
              this.handleGoBack()
            }
          })
        }
        // 修改
        if (formData.id !== null) {
          updateAdminer(formData.id, formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Adminer update successfully !')
              this.handleGoBack()
            }
          })
        }
      })
    },
    loadEditInfo (data) {
      var formData = null
      var createFlag = true
      if (data === '') {
        // 新增
        formData = { 'id': null, 'userName': null, 'mobile': null, 'email': null, 'enabledSwitch': true, 'password': null, 'confirmPassword': null }
        this.adminerRoles = undefined
      } else {
        createFlag = false
        // 编辑
        formData = pick(data, ['id', 'userName', 'mobile', 'email'])
        // 状态切换
        formData.enabledSwitch = data.enabledFlag === '1'
      }
      this.createFlag = createFlag
      console.debug('formData', formData)
      this.editForm.setFieldsValue(formData)
    },
    // 确认密码验证方法
    passwordConfirmValidator (rule, value, callbackFunction) {
      if (value && value !== this.editForm.getFieldValue('password')) {
        callbackFunction('Two inconsistencies in the password.')
      }
      // 必须总是返回一个 callback，否则 validateFields 无法响应
      callbackFunction()
    }
  }
}
</script>
